<app-input-table
  #inputTable
  [formItems]="formItemsReadOnly"
>
</app-input-table>
